module.exports = __webpack_public_path__ + "media/images/new/icons/twitter-0cf70156f0716194ce1175d7d74a29a0.png";